import React from 'react'

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import InputLabel from '@material-ui/core/InputLabel'
import InputAdornment from '@material-ui/core/InputAdornment'
import Input from '@material-ui/core/Input'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Select from '@material-ui/core/Select'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import DialogContentText from '@material-ui/core/DialogContentText'

import GraphSettingsThresholdsSet from './GraphSettingsThresholdsSet'

const GraphThresholdsWindow  = ({ visible, dataViewType, thresholdDisplayType, thresholdValues, inputErrors, cancelBtnClickHandler, saveButtonClickHandler, inputChangeHandler, materialStyles }) => {

  if (!visible) return null

  const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      width: '25ch',
    },
  }))

  const classes = useStyles()

  const thresholdsSet = GraphSettingsThresholdsSet(dataViewType)

  console.log('thresholdsSet',thresholdsSet)

  const styles = {
    overlay: {
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      position: 'fixed',
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 30,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    outer: {
      borderWidth: 2,
      borderStyle: 'solid',
      borderColor: '#666',
      borderRadius: 3,
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      padding: 10,
      border: '2px solid black'
    },
    content: {
      display: 'inline-flex',
    },
    buttonsContainer: {
      display: 'inline-flex',
      justifyContent: 'flex-end',
      paddingTop: '10px',
      padding: '10px',
    },
    button: {
      border: '2px solid #2F6BE1',
      borderRadius: '3px',
      padding: '4px 8px',
      fontSize: '12px',
      color: '#2F6BE1',
      marginLeft: '10px',
      cursor: 'pointer',
    },
  }

  const ret = <Dialog
      disableBackdropClick
      disableEscapeKeyDown={false}
      open={visible}
    >
      <DialogTitle id="form-dialog-title">Set Graph Thresholds</DialogTitle>
      <form autoComplete="off">
        <DialogContent className={materialStyles.dialogContent}>
          <div>
            <FormControl fullWidth={true} className={materialStyles.formControl}>
              {thresholdsSet.thresholds.map((threshold, index) => {
                return <div key={index}>
                <FormGroup className={materialStyles.horizontalFields} >
                  <TextField
                    label={threshold.label}
                    name={threshold.key}
                    className={clsx(useStyles.margin, useStyles.textField)}
                    type={"number"}
                    error={inputErrors[threshold.key] || ''}
                    value={thresholdValues[threshold.key]}
                    onChange={inputChangeHandler}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">{thresholdsSet.unit}</InputAdornment>,
                      step: 1/Math.pow(10,1),
                    }}
                  />
                </FormGroup>
              </div>})}
            </FormControl>
          </div>
        </DialogContent>
      </form>
    <div style={styles.buttonsContainer}>
      <div style={styles.button} onClick={cancelBtnClickHandler} key={1}>
        Cancel
      </div>
      <div style={styles.button} onClick={saveButtonClickHandler} key={2}>
        Save
      </div>
    </div>
  </Dialog>
  return ret
}

export default GraphThresholdsWindow



// WEBPACK FOOTER //
// ./src/components/dataViews/controls/GraphThresholdsWindow.js